/**
 * @requires ./frc.js
 */

frc.modules.geoSearchCombo = function($form){
	var self = this;
	self.config = {
		"suggestionsDelayMS": 500,
		"suggestionsRestrictionBounds": [[49.3457868, -124.7844079], [24.7433195, -66.9513812]],
		"suggestionRestructionTypes": [
			"locality",
			"sublocality",
			"administrative_area1",
			"administrative_area2",
			"postal_code"
		],
		"autoSubmit": null
	};
	self.data = {
		"$form": $form,
		"$findLocationZip": null,
		"$queryField": null,
		"$suggestionsField": null,
		"geocoder": null,
		"autocomplete": null,
		"tmr": null,
		"submitFunction": null
	};

	self.formatSuggestion = function(suggestion){
		var ret = "";
		var lastCharPos = 0;
		suggestion.matched_substrings.forEach(function(_substring){
			ret += suggestion.description.substring(lastCharPos, _substring.offset);
			ret += "<strong>" + suggestion.description.substr(_substring.offset, _substring.length) + "</strong>";
			lastCharPos = _substring.offset + _substring.length;
		});
		ret += suggestion.description.substr(lastCharPos).replace(", USA", "");
		return ret;
	};

	self.deferGetSuggestions = function(){

		self.hideSuggestions();

		if(self.data.tmr){
			window.clearTimeout(self.data.tmr);
		}
		self.data.tmr = window.setTimeout(function(){
			self.getSuggestions(function(results){
				self.renderSuggestions(results);
			});
		}, self.config.suggestionsDelayMS);
	}

	self.init = function(){

		self.config.autoSubmit = self.data.$form.attr("data-auto-submit") == "true";
		self.data.$findLocationZip = self.data.$form.find(".find-location-zip");
		self.data.$queryField = self.data.$form.find("input[name=\"query\"]");
		
		self.data.$suggestionsField = self.data.$form.find("ul.suggestions");
		if(self.data.$suggestionsField.length){
			self.data.$queryField.on("input", self.deferGetSuggestions);
			self.data.$suggestionsField.on("click", function(e){
				var val = $(e.target).attr("data-val") || $(e.target).parents("[data-val]").attr("data-val");
				if(val){
					// Suggestion selected
					self.hideSuggestions();
					self.data.$queryField.val(val);

					if(self.data.submitFunction){
						self.data.submitFunction("suggestionclicked");
					} else {
						self.submit({
							"type": "suggestionclicked",
							"params": {
								"query": val
							}
						});
					}
				}
			});
		}

		self.data.$form.on("submit", function(e){
			e.preventDefault();
			var query = jQuery.trim(self.data.$queryField.val());
			if(query){
	   			if(self.data.submitFunction){
	   				self.data.submitFunction("formsubmitted");
	   			} else {
	            	self.submit({
	            		"type": "formsubmitted"
	            	});
	   			}
			}
		});

        self.data.$form.find('.geolocate').on('click', function() {
        	var currentQuery = self.data.$queryField.val();
        	self.data.$queryField.val("Locating...");
        	$(this).addClass('loading');
            frc.utilities.geolocate(function(result) {
                if(result.coords) {
               		if(self.config.autoSubmit){
               			if(self.data.submitFunction){
               				self.data.submitFunction("geolocation");
               			} else {
		                	self.submit({
		                		"type": "geolocation",
		                		"coords": result.coords
		                	});
               			}
               		} else {
						$(self).trigger("geolocationcomplete", result);
               		}
                } else {
                	self.data.$queryField.val(currentQuery);
                }
                self.data.$form.find('.geolocate').removeClass('loading');
            });
        });

	};

	self.submit = function(submitContext){
		var params = {};
		if(self.data.$form.prop("action") && submitContext){
			if(submitContext.params){
				params = submitContext.params;
			} else {
				if(submitContext.type=="geolocation"){
					params.coords = submitContext.coords.join(",");
				} else {
					params.query = jQuery.trim(self.data.$queryField.val());
				}
			}
			window.location.href = self.data.$form.prop("action") + "?" + jQuery.param(params);
		}
	};

	self.getSuggestions = function(callback){

		if(!self.data.$suggestionsField || !self.data.$suggestionsField.length){
			return;
		}

		if(!self.data.autocomplete && (typeof google) != "undefined" && (typeof google.maps) != "undefined" && (typeof google.maps.places) != "undefined" && (typeof google.maps.places.AutocompleteService) != "undefined"){
			self.data.autocomplete = new google.maps.places.AutocompleteService();
		}

		var query = jQuery.trim(self.data.$queryField.val());
		if(query && query.length>3){
			var cacheKey = "geocode-" + window.btoa(query.toLowerCase());
			var cachedData = frc.utilities.cache.get(cacheKey);
			if(cachedData){
				callback(cachedData);
				return;
			}

			var bounds = new google.maps.LatLngBounds(
				new google.maps.LatLng(self.config.suggestionsRestrictionBounds[0][0], self.config.suggestionsRestrictionBounds[0][1]),
				new google.maps.LatLng(self.config.suggestionsRestrictionBounds[1][0], self.config.suggestionsRestrictionBounds[1][1])
			);

			self.data.autocomplete.getQueryPredictions({ // See https://developers.google.com/maps/documentation/javascript/3.exp/reference#QueryAutocompletionRequest
				"input": query,
				"bounds": bounds
			}, function(predictions, status){
				if(status==google.maps.places.PlacesServiceStatus.OK){

					var suggestions = [];
					predictions.forEach(function(prediction){
						if(prediction.description.indexOf(", USA")>-1 && frc.utilities.arrayIntersection(prediction.types, self.config.suggestionRestructionTypes).length){
							suggestions.push({
								"text": prediction.description.replace(", USA", ""),
								"html": self.formatSuggestion(prediction)
							});
						}
					});
					frc.utilities.cache.set(cacheKey, suggestions, false);

					if(suggestions.length){
						callback(suggestions);
					}
				}
			});
		}
	};

	self.showSuggestions = function(){
		self.data.$suggestionsField.addClass("active");
	}

	self.hideSuggestions = function(){
		self.data.$suggestionsField.removeClass("active");
		self.data.$suggestionsField.empty();
	}

	self.renderSuggestions = function(suggestions){
		if(suggestions.length){
			self.data.$suggestionsField.empty();
			suggestions.forEach(function(suggestion){
				var $li = $("<li>" + suggestion.html + "</li>").attr("data-val", suggestion.text);
				self.data.$suggestionsField.append($li);
			});
			self.showSuggestions();
		}
	}

	self.init();
	return self;

}